<template>
  <div>
    <h3 class="mt-5">
      <span class="fa-square-primary mr-3">
        <font-awesome :icon="['far', group.icon]"/>
      </span>

      {{ group.name }}
    </h3>

    <div class="card">
      <ul class="list-data no-links">
        <li class="data-heading d-none d-xl-block">
          <div class="row">
            <div class="col-12 col-sm-12 col-lg-12 col-xl-7">Capability Name</div>
            <div class="col-12 col-sm-6 col-lg-3 col-xl-2">Level</div>
            <div class="col-12 col-sm-12 col-lg-5 col-xl-3">Initial Setting</div>
          </div><!-- /.row -->
        </li>

        <capability-item v-for="capability in group.capabilities" :capability="capability" :key="capability.id"/>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->
  </div>
</template>

<script>
import CapabilityItem from './GraduatesSingleInitialCapabilityItem'

export default {
  inject: ['$validator'],

  props: {
    group: {
      required: true,
      type: Object
    }
  },

  components: {
    CapabilityItem
  }
}
</script>
